import React, { useState, useEffect } from 'react';
import './AdminStats.css';
import API_BASE_URL from '../config/api';

const AdminMissingClaims = () => {
  const [claims, setClaims] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchClaims();
  }, []);

  const fetchClaims = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_BASE_URL}/api/missing/claims`);
      const data = await res.json();
      if (data.success) {
        setClaims(data.data);
      }
    } catch (error) {
      console.error("Error fetching missing claims:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateStatus = async (id, newStatus) => {
    if (!window.confirm(`Mark this claim as ${newStatus}?`)) return;

    try {
      const res = await fetch(`${API_BASE_URL}/api/missing/claims/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ status: newStatus })
      });
      const data = await res.json();
      
      if (data.success) {
        setClaims(claims.map(c => c._id === id ? { ...c, status: newStatus } : c));
        alert(`Claim successfully marked as ${newStatus}`);
      } else {
        alert(data.error || "Failed to update");
      }
    } catch (error) {
      console.error("Error updating claim:", error);
      alert("Error updating claim");
    }
  };

  return (
    <div className="admin-stats-container">
      <h2>Admin Dashboard - Missing Certificate Claims</h2>
      
      <div className="filters-container">
        <div className="total-count-box">
          Pending Review: <strong>{claims.filter(c => c.status === 'Pending').length}</strong>
        </div>
      </div>

      <div className="table-container">
        {loading ? (
          <div className="loading-state">Loading claims...</div>
        ) : (
          <table className="stats-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Email</th>
                <th>USN</th>
                <th>Phone</th>
                <th>Event</th>
                <th>Submitted</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {claims.length > 0 ? (
                claims.map((claim, index) => (
                  <tr key={claim._id} style={{ 
                    backgroundColor: claim.status === 'Resolved' ? 'rgba(34, 197, 94, 0.1)' : 
                                     claim.status === 'Rejected' ? 'rgba(239, 68, 68, 0.1)' : 'transparent' 
                  }}>
                    <td>{index + 1}</td>
                    <td>{claim.name}</td>
                    <td>{claim.email}</td>
                    <td>{claim.usn}</td>
                    <td>{claim.phone || '-'}</td>
                    <td><span className="event-badge">{claim.event}</span></td>
                    <td>{new Date(claim.submittedAt).toLocaleString()}</td>
                    <td>
                      <span className={`status-badge`} style={{ 
                        color: claim.status === 'Pending' ? '#eab308' : 
                               claim.status === 'Resolved' ? '#22c55e' : '#ef4444' 
                      }}>
                        {claim.status}
                      </span>
                    </td>
                    <td>
                      {claim.status === 'Pending' && (
                        <div style={{ display: 'flex', gap: '8px' }}>
                          <button 
                            style={{ padding: '4px 8px', background: '#22c55e', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                            onClick={() => handleUpdateStatus(claim._id, 'Resolved')}
                          >
                            Resolve
                          </button>
                          <button 
                            style={{ padding: '4px 8px', background: '#ef4444', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                            onClick={() => handleUpdateStatus(claim._id, 'Rejected')}
                          >
                            Reject
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="no-data">No missing claims found</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AdminMissingClaims;
